module.exports = __webpack_public_path__ + "static/media/office_5.bd53d196.jpg";